import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';

export type EchartsMapFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric?: string;
    showLabels: boolean;
    tooltipFormat: string;
    geoJSON: string;
    colorRange: string[];
};

export interface EchartsMapChartProps
  extends ChartProps<EchartsMapFormData> {
  formData: EchartsMapFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsMapFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  tooltipFormat: '{a} <br/>{b}: {c}',
  geoJSON: '',
  colorRange: [
    '#313695',
    '#4575b4',
    '#74add1',
    '#abd9e9',
    '#e0f3f8',
    '#ffffbf',
    '#fee090',
    '#fdae61',
    '#f46d43',
    '#d73027',
    '#a50026'
  ]
};

export interface MapChartTransformedProps {
  formData: EchartsMapFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}